import { Component, DestroyRef, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState, selectFilters } from '@cbcore/NGRX/core.state';
import { SyndicatesScope } from '@cbcore/NGRX/syndicates/syndicates.model';
import { CalculationsService } from "@cbcore/services/utils/calculations/calculations.service";
import { Config } from "@cbcore/services/config/config.service";
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ImagesLazyLoadDirective } from '../../../helpers/directives/images-lazy-load';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';

@Component({
    selector: 'widget-syndicate-list-card',
    templateUrl: './syndicate-list-card.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PipesModule,
    TranslocoModule,
    CommonModule,
    
        ImagesLazyLoadDirective
    ]
})
export class WidgetSyndicateListCardComponent implements OnInit {
  @Input('syndicate') syndicate: any;
  @Input('showPercentage') showPercentage!: boolean; // Always bound by real consumers
  public imagesUrl!: string; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public fallbackMangerImage!: string; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public showPoolBestDividend!: boolean; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public status!: string; // Assigned synchronously in ngOnInit's filters$ subscribe (NgRx selectors emit synchronously on subscribe) — pre-existing assumption, not independently verified

  private filters$!: Observable<SyndicatesScope.Pagination>; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  private destroyRef = inject(DestroyRef);

  constructor(
    private _config: Config,
    private _calculationsService: CalculationsService,
    private store: Store<AppState>
  ) {
  }

  ngOnInit(): void {
    this.imagesUrl = this._config.CONFIG.imagesUrl;
    this.showPoolBestDividend = this._config.CONFIG.showPoolBestDividend;
    this.fallbackMangerImage = this._config.CONFIG.fallbackSyndicateProfileImage;

    this.filters$ = this.store.select(selectFilters);
    this.filters$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(filters => {
      this.status = (<any>filters).status;
    });
  }

  calculatePrize(prizeAmount: string, isFixed?: boolean): any {
    if (this.syndicate) {
      const maxStake = this._calculationsService.getMaxStake(this.syndicate.pool.stake_sizes[0].stakes);
      if (isFixed) {
        return this._calculationsService.calculatePrize(prizeAmount, maxStake);
      }
      return this._calculationsService.calculatePrize(prizeAmount, this.syndicate.stake);
    }
  }

  setFallbackImage(): void {
    this.syndicate.manager.picture_url = this.imagesUrl + this.fallbackMangerImage;
  }
}
